class ImageCarousel extends HTMLElement {
  constructor() {
    super();
    this.mainCarousel = null;
    this.thumbnailCarousel = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const autoplay = this.dataset.autoplay === 'true';
    const showThumbnails = this.dataset.showThumbnails === 'true';
    const intervalRaw = this.dataset.autoplayInterval;
    const interval = Number.parseInt(intervalRaw, 10);
    const safeInterval = Number.isFinite(interval) ? interval : 4000;
    const thumbsDesktopRaw = Number.parseInt(this.dataset.thumbsPerPageDesktop, 10);
    const thumbsMobileRaw = Number.parseInt(this.dataset.thumbsPerPageMobile, 10);
    const thumbsPerPageDesktop = Number.isFinite(thumbsDesktopRaw) ? thumbsDesktopRaw : 5;
    const thumbsPerPageMobile = Number.isFinite(thumbsMobileRaw) ? thumbsMobileRaw : 5;

    const mainRoot = this.querySelector('.image-carousel__main');
    if (!mainRoot) {
      return;
    }

    this.mainCarousel = new Splide(mainRoot, {
      arrows: false,
      pagination: false,
      perPage: 1,
      gap: '0',
      drag: true,
      type: 'loop',
      autoplay: autoplay,
      interval: safeInterval,
      pauseOnHover: true,
      breakpoints: {
        768: {
          perPage: 1,
          gap: 'var(--spacing-xs)',
          focus: 0,
        },
      },
    });

    const thumbsRoot = this.querySelector('.image-carousel__thumbs');
    if (showThumbnails && thumbsRoot) {
      this.thumbnailCarousel = new Splide(thumbsRoot, {
        arrows: false,
        pagination: false,
        isNavigation: true,
        gap: 'var(--spacing-4xs)',
        perPage: thumbsPerPageDesktop,
        direction: 'ttb',
        wheel: true,
        drag: true,
        focus: 0,
        breakpoints: {
          768: {
            direction: 'ltr',
            perPage: thumbsPerPageMobile,
          },
        },
      });

      this.mainCarousel.sync(this.thumbnailCarousel);
      this.thumbnailCarousel.mount();
    }

    this.mainCarousel.mount();
  }
}

customElements.define('image-carousel', ImageCarousel);

